var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper btn--circle"},[_c('span',{staticClass:"icon material-icons text-blue"},[_vm._v(" "+_vm._s(_vm.icon)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }